import { UploadCloud01 } from "untitledui-js-base";
import { cx } from "shared/utils";
import { useCallback, useRef, MutableRefObject, FC } from "react";
import { toast } from "react-toastify";
import { UploadedFile } from "../../types";

interface Props {
  files: UploadedFile[];
  setFiles: (files: UploadedFile[]) => void;
}

export const DocumentDropZone: FC<Props> = ({ files, setFiles }) => {
  const uploader = useRef<HTMLInputElement>();

  const handleChange = useCallback(
    (e) => {
      if (!e.target.files?.length) return;
      const selectedFiles = Array.from<File>(e.target.files);
      const validFiles: UploadedFile[] = [];
      selectedFiles.forEach((file) => {
        if (!file.type.match(/image\/.*|application\/pdf/))
          toast.error(
            "The file format is not valid. Please upload a PDF, IMAGE file."
          );
        else if (file.size > 25 * 1024 * 1024)
          toast.error(
            <>
              <p className="font-bold text-sm">{`${file.name} could not be uploaded`}</p>
              <p className="text-sm">Maximum file size allowed: 25 MB</p>
            </>,
            {
              style: { width: "400px" }
            }
          );
        else validFiles.push({ file });
      });
      setFiles([...files, ...validFiles]);
      if (uploader.current?.value) uploader.current.value = "";
    },
    [files, setFiles]
  );

  return (
    <label
      className={cx(
        "animate-appear relative flex h-[140px] w-full cursor-pointer flex-col items-center justify-center gap-2 rounded-lg border border-dashed border-primary-500 bg-primary-20 hover:bg-primary-50 mb-6"
      )}
      htmlFor="additional-document"
    >
      <div className="flex flex-col items-center justify-center gap-2 pb-6 pt-5">
        <UploadCloud01 className="stroke-primary-500 stroke-2" size="24" />
        <p className="text-sm font-medium text-primary-500">Upload documents</p>

        <p className="text-xs font-medium text-primary-300">
          Maximum file size allowed: 25 MB
        </p>
      </div>

      <input
        ref={uploader as MutableRefObject<HTMLInputElement>}
        accept="image/*,.pdf"
        className="absolute left-0 h-[140px] w-full opacity-0"
        id="additional-document"
        multiple={true}
        onChange={handleChange}
        required={false}
        type="file"
      />
    </label>
  );
};
